import MainPage from './app/pages/MainPage';
import Candidates from './app/pages/Candidates';
import About from './app/pages/About';
import Jobs from './app/pages/Jobs';
import JobsPage from './app/pages/Jobs/page';
import Interium from './app/pages/InterimLeadership';
import Executive from './app/pages/ExecutiveLeadership';
import Critical from './app/pages/CriticalAccess';
import Mentorship from './app/pages/Mentorship';
import LocumTenens from './app/pages/LocumTenens';
import Survey from './app/pages/Survey';
import Blog from './app/pages/Blog/list';
import Blog1 from './app/pages/Blog/1';
import Blog2 from './app/pages/Blog/2';
import Blog3 from './app/pages/Blog/3';
import Blog4 from './app/pages/Blog/4';
import Blog5 from './app/pages/Blog/5';
import Blog6 from './app/pages/Blog/6';
import Blog7 from './app/pages/Blog/7';
import Blog8 from './app/pages/Blog/8';
import Leadership from './app/pages/LTCLeadership';
import TravelNurse from './app/pages/TravelNurse/index';
import FAQ from './app/pages/TravelNurse/faq';
import Taxes from './app/pages/TravelNurse/tax';
import OperationalAssessment from './app/pages/OperationalAssessment';
import HospitalStaffing from './app/pages/HospitalStaffing';
import RevenueCycleAssessment from './app/pages/RevenueCycleAssessment';
import RevenueCycleSolutions from './app/pages/RevenueCycleSolutions';
import RevenueCycleConsulting from './app/pages/RevenueCycleConsulting';
import Library from './app/pages/Library';
import Referral from './app/pages/Referral';
import CandidatePage from './app/pages/Library/candidate';

import { createBrowserRouter } from 'react-router-dom';

const routes = createBrowserRouter([
  {
    path: '/',
    element: <MainPage />,
  },
  {
    path: '/interim_leadership',
    element: <Interium />,
  },
  {
    path: '/executive_leadership',
    element: <Executive />,
  },
  {
    path: '/LTC_leadership',
    element: <Leadership />,
  },
  {
    path: '/mentorship',
    element: <Mentorship />,
  },
  {
    path: '/critical_access',
    element: <Critical />,
  },
  {
    path: '/hospital_staffing',
    element: <HospitalStaffing />,
  },
  {
    path: '/operational_assessment',
    element: <OperationalAssessment />,
  },
  {
    path: '/survey_readiness',
    element: <Survey />,
  },
  {
    path: '/locum_tenens',
    element: <LocumTenens />,
  },
  {
    path: '/travel_nurse',
    element: <TravelNurse />,
  },
  {
    path: '/travel_nurse/faq',
    element: <FAQ />,
  },
  {
    path: '/travel_nurse/taxes',
    element: <Taxes />,
  },
  {
    path: '/for_candidates',
    element: <Candidates />,
  },
  {
    path: '/about',
    element: <About />,
  },

  {
    path: '/jobs',
    element: <Jobs />,
  },

  {
    path: '/jobs/:id',
    element: <JobsPage />,
  },
  {
    path: '/profiles',
    element: <Library />,
  },
  {
    path: '/profiles/:id',
    element: <CandidatePage />,
  },
  {
    path: '/revenue_cycle_assessment',
    element: <RevenueCycleAssessment />,
  },
  {
    path: '/revenue_cycle_solutions',
    element: <RevenueCycleSolutions />,
  },
  {
    path: '/revenue_cycle_consulting',
    element: <RevenueCycleConsulting />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/referral',
    element: <Referral />,
  },
  {
    path: '/blog/healthcare-CEO-KPIs',
    element: <Blog1 />,
  },
  {
    path: '/blog/the-benefits-of-a-positive-attitude',
    element: <Blog2 />,
  },
  {
    path: '/blog/the-unexpected-loss-of-a-leader',
    element: <Blog3 />,
  },
  {
    path: '/blog/burnout-disengagement-and-low-morale',
    element: <Blog4 />,
  },
  {
    path: '/blog/a-powerful-leadership-tool',
    element: <Blog5 />,
  },
  {
    path: '/blog/how-to-be-successful-working-with-millennials',
    element: <Blog6 />,
  },
  {
    path: '/blog/navigating-major-staffing-shortages-in-healthcare',
    element: <Blog7 />,
  },
  {
    path: '/blog/the-50-mile-myth-for-travelers',
    element: <Blog8 />,
  },
]);

export default routes;
